if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};

//#region Login Steps

rtAPI.security.handle.login = function (event) {
    event.preventDefault();
    var login = rtAPI.security.fd.login.value;
    var password = rtAPI.security.fd.password.value;
    if (!rtAPI.validateRequired('requiredGroupLogin') || login == '' || password == '') return;
    rtAPI.security.call.login(login, password, rtAPI.security.samePageLogin, rtAPI.security.fd.manageTFA.checked)
        .then(result => {
            if (result.statusOk) {
                rtAPI.security.fireTFAHardwareKeyLoginWhenSelected = true;
                rtAPI.security.showTFAManagement = rtAPI.security.fd.manageTFA.checked;
                rtAPI.security.clearFields();
                rtAPI.resetRequired();
            }
            rtAPI.security.updatePanels(result)
        })
}

rtAPI.security.handle.showLostPassword = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.login.style.display = 'none';
    rtAPI.security.pnl.lostPassword.style.display = 'inherit';
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

rtAPI.security.handle.getLostPassword = function (event) {
    event.preventDefault();
    var userName = rtAPI.security.fd.loginLost.value;
    if (!rtAPI.validateRequired('requiredGroupLostPassword') || userName == '') return;
    rtAPI.security.call.getLostPassword(userName)
    rtAPI.security.handle.showLoginPanel(event)
}

rtAPI.security.handle.showLostUsername = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.login.style.display = 'none';
    rtAPI.security.pnl.lostUsername.style.display = 'inherit';
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

rtAPI.security.handle.getLostUsername = function (event) {
    event.preventDefault();
    var email = rtAPI.security.fd.loginLostEmail.value;
    if (!rtAPI.validateRequired('requiredGroupLostUsername') || email == '') return;
    rtAPI.security.call.getLostUsername(email)
    rtAPI.security.handle.showLoginPanel(event)
}

rtAPI.security.handle.showResendAuthEmail = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.login.style.display = 'none';
    rtAPI.security.pnl.resendAuthEmail.style.display = 'inherit';
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

rtAPI.security.handle.resendAuthEmailSend = function (event) {
    event.preventDefault();
    var userName = rtAPI.security.fd.resendAuthEmail.value;
    if (!rtAPI.validateRequired('requiredGroupResendAuthEmail') || userName == '') return;
    rtAPI.security.call.resendAuthEmail(userName)
    rtAPI.security.handle.showLoginPanel(event)
}

rtAPI.security.handle.showLoginPanel = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.login.style.display = 'inherit';
    rtAPI.security.pnl.lostPassword.style.display = 'none';
    rtAPI.security.pnl.lostUsername.style.display = 'none';
    rtAPI.security.pnl.resendAuthEmail.style.display = 'none';
    rtAPI.security.fd.loginLost.value = '';
    rtAPI.security.fd.resendAuthEmail.value = '';
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

//#endregion

//#region Logout

rtAPI.security.handle.logout = function (event) {
    event.preventDefault();
    rtAPI.security.call.logout()
        .then(result => {
            rtAPI.security.clearFields();
            rtAPI.security.updatePanels(result);
            rtAPI.resetRequired();
        })
}

//#endregion

//#region 2FA - Respond

rtAPI.security.handle.sendSelect2FAMethod = async function (event) {
    var selectedMethod = document.querySelector('input[name="tFAOptions"]:checked').value;
    let result = await rtAPI.security.call.sendSelectedMethod(selectedMethod)
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAAuthenticateCodeSend = function (event) {
    event.preventDefault();
    var authCode = rtAPI.security.fd.authenticationCode.value;
    if (!rtAPI.validateRequired('requiredGroupAuthCode') || authCode == '') return;
    rtAPI.security.call.sendAuthCode(authCode)
        .then(result => {
            if (result.statusOk) rtAPI.resetRequired();
            rtAPI.security.updatePanels(result);
        })
}

rtAPI.security.handle.tFAMemorableDataSend = function (event) {
    event.preventDefault();
    var memorableData1 = document.getElementById('memorableData1').value;
    var memorableData2 = document.getElementById('memorableData2').value;
    var memorableData3 = document.getElementById('memorableData3').value;
    if (!rtAPI.validateRequired('requiredGroupMemorableData') || memorableData1 == '' || memorableData2 == '' || memorableData3 == '') return;
    rtAPI.security.call.sendMemorableData(memorableData1, memorableData2, memorableData3)
        .then(result => {
            if (result.statusOk) rtAPI.resetRequired();
            rtAPI.security.updatePanels(result);
        })
}

rtAPI.security.handle.tFAHardwareKeyRegister = async function (event) {
    event.preventDefault();
    let hardwareKeyResult = await rtAPI.security.hardwareKey.registrationStep1();
    if (!hardwareKeyResult) {
        //rtAPI.security.tFAManageUpdateMessagesUpdate();
        return;
    };
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.updateManageHardwareKeyPanels(result);
    Swal.fire({
        title: rtAPI.security.tFAData.text.registeredNewHardwareKeyTitle,
        text: rtAPI.security.tFAData.text.registeredNewHardwareKeyText,
        imageUrl: "/resources/securitykey.min.svg",
        showCancelButton: false,
        showConfirmButton: true,
        focusConfirm: true,
        focusCancel: false
    });
}

rtAPI.security.handle.tFAHardwareKeyRetry = async function (event) {
    event.preventDefault();
    await rtAPI.security.hardwareKey.triggerLogin()
}

rtAPI.security.handle.tFAAuthenticateCancel = function (event) {
    event.preventDefault();
    rtAPI.security.call.cancelTFA()
        .then(result => {
            rtAPI.security.updatePanels(result);
            rtAPI.resetRequired();
        })
}

//#endregion

//#region 2FA Manage

rtAPI.security.handle.showMFM = async function (event) {
    event.preventDefault();
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.showTFAManagement = true;
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAManageUpdate = async function (event) {
    event.preventDefault();
    //rtAPI.security.tFAManageUpdateMessagesClear();
    rtAPI.messages.clear();
    if (rtAPI.security.tFAManageOptionsAreValid()) {
        let hardwareKeyOption = rtAPI.security.get2FAOption('HardwareKey');
        if (hardwareKeyOption.enabled != hardwareKeyOption.newState && hardwareKeyOption.newState) {
            let hardwareKeyResult = await rtAPI.security.hardwareKey.registrationStep1();
            if (!hardwareKeyResult) {
                //rtAPI.security.tFAManageUpdateMessagesUpdate();
                return;
            };
        }
        rtAPI.security.call.tFAManageOptionsUpdate(rtAPI.security.tFAData)
            .then(result => {
                if (result.statusOk) {
                    if (result.tFAData.updateStatusOk) {
                        rtAPI.security.tFAData = result.tFAData;
                    }
                    //else {
                    //    rtAPI.security.tFAManageUpdateMessagesSet(result);
                    //}
                }
                rtAPI.security.update2FAManagePanel();
            })
    }
    //rtAPI.security.tFAManageUpdateMessagesUpdate();
}

rtAPI.security.handle.tFAManageOptionToggle = function (event) {
    var option = rtAPI.security.get2FAOption(this.value);
    option.newState = this.checked;

    if (!option.newState) {
        for (const field of option.fields) {
            field.value = field.initialValue;
        }
    }
    rtAPI.security.update2FAManagePanel();
}

rtAPI.security.handle.tFAManageFieldInput = function (event) {
    event.preventDefault();
    rtAPI.security.get2FAOptionField(this.id).value = this.value;
    rtAPI.security.update2FAManagePanel();
}

rtAPI.security.handle.tFAManageOptionHardwareKey = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.init2FAManageHardwareKeyPanel();
}

rtAPI.security.handle.tFAManageOptionDeviceAuthentication = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.init2FAManageAuthorisedDevicePanel();
}

rtAPI.security.handle.tFAManageHardwareKeyAdd = async function (event) {
    event.preventDefault();
    let hardwareKeyResult = await rtAPI.security.hardwareKey.registrationStep1();
    if (!hardwareKeyResult) {
        //rtAPI.security.tFAManageUpdateMessagesUpdate();
        return;
    };
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.updateManageHardwareKeyPanels(result);
}

rtAPI.security.handle.tFAManageHardwareKeyRemove = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.removeHardwareKeyTitle.replace('{0}', this.userIdent),
        text: rtAPI.security.tFAData.text.removeHardwareKeyText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Remove',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.registrationRemove(this.idDB);
    rtAPI.security.updateManageHardwareKeyPanels(result);
}

rtAPI.security.handle.tFAManageHardwareKeyAuthorise = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.authoriseHardwareKeyTitle.replace('{0}', this.userIdent),
        text: rtAPI.security.tFAData.text.authoriseHardwareKeyText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Authorise',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.registrationAuthorise(this.idDB);
    rtAPI.security.updateManageHardwareKeyPanels(result);
}

rtAPI.security.handle.tFAManageAuthorisedDeviceRemove = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.removeDeviceTitle.replace('{0}', this.name),
        text: rtAPI.security.tFAData.text.removeDeviceText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Remove',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.authorisedDeviceRemove(this.idDB);
    rtAPI.security.updateManageAuthorisedDevicePanels(result);
}

rtAPI.security.handle.tFAManageAuthorisedDeviceAuthorise = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.authoriseDeviceTitle.replace('{0}', this.name),
        text: rtAPI.security.tFAData.text.authoriseDeviceText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Approve',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.authorisedDeviceAuthorise(this.idDB);
    rtAPI.security.updateManageAuthorisedDevicePanels(result);
}

rtAPI.security.handle.tFAManageBack = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.init2FAManagePanel();
}

rtAPI.security.handle.tFAManageAutoClose = function (event) {
    rtAPI.security.pnl.dialog.style.cursor = null;
    rtAPI.security.pnl.dialog.removeAttribute("onclick");
    rtAPI.security.handle.tFAManageCloseCommon(event);
}

rtAPI.security.handle.tFAManageClose = function (event) {
    rtAPI.security.handle.tFAManageCloseCommon(event);
    rtAPI.security.call.tFAManageOptionsClose();
}

rtAPI.security.handle.tFAManageCloseCommon = function (event) {
    event.preventDefault();
    rtAPI.security.showTFAManagement = false;
    rtAPI.security.pnl.dialogButtons.innerHTML = '';
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.pnl.dialog.style.display = 'none';
}

//#endregion

//#region Hardware Key

//#endregion

//#region Update Password

rtAPI.security.handle.showUpdatePassword = function (event) {
    event.preventDefault();
    rtAPI.displayElement(rtAPI.security.pnl.updatePassword, '');
    rtAPI.displayElement(rtAPI.security.btn.updatePassword, '');
    rtAPI.messages.targetSuffix = 'UpdatePassword';
}

rtAPI.security.handle.updatePassword = function (event) {
    event.preventDefault();
    rtAPI.security.fd.retypeNewPassword.setCustomValidity('');
    rtAPI.messages.clear();
    var oldPassword = rtAPI.security.fd.oldPassword.value;
    var newPassword = rtAPI.security.fd.newPassword.value;
    var retypeNewPassword = rtAPI.security.fd.retypeNewPassword.value;
    if (!rtAPI.validateRequired('requiredGroupUpdatePassword') || oldPassword == '' || newPassword == '' || retypeNewPassword == '') return;
    if (newPassword != retypeNewPassword) {
        rtAPI.security.fd.retypeNewPassword.setCustomValidity(rtAPI.security.errorMessage.retypeNewPassword);
        rtAPI.messages.showCritical(rtAPI.security.errorMessage.retypeNewPasswordMustMatch);
        return;
    }
    if (!rtAPI.security.fd.newPassword.isValidPassword) {
        rtAPI.security.fd.newPassword.setCustomValidity(rtAPI.security.errorMessage.weakPassword);
        rtAPI.messages.showCritical(rtAPI.security.errorMessage.weakPassword);
        return;
    }
    rtAPI.security.call.updatePassword(oldPassword, newPassword, retypeNewPassword)
        .then(result => {
            if (result.statusOk) {
                if (result.passwordUpdated) {
                    rtAPI.displayElement(rtAPI.security.btn.updatePassword, 'none');
                }
            }
        })
}

rtAPI.security.handle.updatePasswordClose = function (event) {
    event.preventDefault();
    rtAPI.displayElement(rtAPI.security.pnl.updatePassword, 'none');
    rtAPI.security.clearFields();
    rtAPI.messages.clear();
    rtAPI.resetRequired();
    rtAPI.messages.targetSuffix = '';
}

rtAPI.security.handle.inputPasswordField = function (event) {
    var pwd = this.value;
    var id = this.id;
    this.isValidPassword = pass_chkPass(pwd, id);
    //if (this.isValidPassword) this.setCustomValidity('weak')
    //else this.setCustomValidity('')
}

//#endregion
